<template>
  <!-- 用户列表 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form
        ref="form"
        :model="searchParams"
        label-width="auto"
        class="from"
        label-position="right"
      >
        <el-form-item :label="$t('pages.system.text66')">
          <el-input
            v-model="searchParams.account"
            :placeholder="$t('public.text1')"
            style="width:200px"
            clearable 
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.user.text31')">
          <el-select 
            v-model="searchParams.ctype"
            :placeholder="$t('public.text5')" 
            style="width:150px"
            clearable 
          >
            <el-option :label="$t('omission.text77')" :value=1> </el-option>
            <el-option :label="$t('omission.text78')" :value=2> </el-option>
            <el-option :label="$t('omission.text79')" :value=3> </el-option>
            <el-option :label="$t('omission.text80')" :value=4> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('pages.user.text4')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
            style="width:200px"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
            style="width:200px"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton type="search" @click="search" v-permission="['verifyList:query']"/>
        <DiluButton type="reset" @click="reset" v-permission="['verifyList:reset']"/>
      </div>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      :total="total"
    >
      <el-table-column 
        prop="id" 
        label="#" 
        width="60px" 
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="account"
        :label="$t('pages.system.text66')"
        align="center"
        width="280"
      >
      </el-table-column>
      <el-table-column
        prop="code"
        :label="$t('menu.verifyList')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ctype"
        :label="$t('pages.user.text31')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createdAt"
        :label="$t('pages.user.text4')"
        align="center"
        width="280"
      >
      </el-table-column>
    </DiluTable>
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import { mapState } from "vuex";
import { resetDate } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        appCode: "", //平台代码
        account: "", //账号
        ctype: null, //场景
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
        pageNum: 1, //页码
        pageSize: 10, //每页条数
      },
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      total: 0,
      options: [],
      tableData: [],
      isSerch: false, //是否在查询
      typeList: [
        {
          value: 1,
          label: this.$t("omission.text77"),
        },
        {
          value: 2,
          label: this.$t("omission.text78"), 
        },
        {
          value: 3,
          label: this.$t("omission.text79"), 
        },
        {
          value: 4,
          label: this.$t("omission.text80"),
        }
      ]
    };
  },
  components: {
    DiluTable,
    DiluButton,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.verifyList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.verifyList();
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    //获取网络升级任务列表
    verifyList() {
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text4"));
        }
      }
      if (this.searchParams.ctype=="") {
        this.searchParams.ctype=null;
      }
      this.searchParams.appCode = this.platformData.appCode;
      this.request
        .verifyList(this.searchParams)
        .then((res) => {
          this.tableData = res.data;
          this.total = res.dataMaxCount;
        })
        .catch(() => {});
    },
    // 重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        appCode: "", //平台代码
        account: "", //账号
        ctype: null, //场景
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
        pageNum: 1, //页码
        pageSize: 10, //每页条数
      };
      this.total = 0;
      this.verifyList();
    },
    //翻页
    currentChange(e) {
      this.searchParams = {
        appCode: "", //平台代码
        account: "", //账号
        ctype: null, //场景
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
        pageNum: 1, //页码
        pageSize: 10, //每页条数
      };
      this.searchParams.pageNum = e;
      this.verifyList();
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
  flex-wrap: wrap;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>